// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TcSg","left":"styles_left__1XubZ","desktopActions":"styles_desktopActions__2v7lM","title":"styles_title__3JTjO"};